module.exports = __webpack_public_path__ + "img/newspapper.b6e579dc.jpg";